<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="lg">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{ __('edit_groups_by_currency') }} <button-open-help-modal :color="'dark'" :in-extra-div="false" :helpName="analyzeType == 'sell'? 'ASA-006' : 'ASB-006'"/></h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}">
            <div>
                <label>
                    <input type="radio" :value="'detailed'" v-model="analyzeLevel.currency_segregation"/>
                    {{ __('each_currency_separately') }}
                </label>
            </div>
            <div>
                <label>
                    <input type="radio" :value="'dual'" v-model="analyzeLevel.currency_segregation"/>
                    {{ radioButtonTitle }}
                </label>
            </div>
        </template>
        <template v-slot:modal-footer="{}">
            <div class="row m-b">
                <div class="col white-space-no-wrap">
                    <button type="button" class="btn btn-white" v-on:click="visible = false">{{__('cancel')}}</button>
                </div>
                <div class="col white-space-no-wrap">
                    <button type="button" class="btn btn-primary" @click="saveCurrenciesGroup()">{{__('save')}}</button>
                </div>

            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "ModalEditCurrencyGroup",
    data: function () {
        return {
            visible: false,
        }
    },
    props: {
        analyzeLevel: {
            type: Object
        },
        radioButtonTitle: {
            type: String
        },
        analyzeType: {
            type: String
        },
    },
    methods:{
        saveCurrenciesGroup: function (){
            this.$emit('saveCurrenciesGroup')
        }
    }
}
</script>

<style scoped>

</style>
